import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  isContentChange: false,
  locked: false,
  currentState: null,
  redoStack: [],
  stateStack: [],
  toogleAutoSaveRevision: false,
};

const stateManagerSlice = createSlice({
  name: 'stateManager',
  initialState: INITIAL_STATE,
  reducers: {
    removeLastStackState: (state) => {
      const oldStateStack = state.stateStack;
      oldStateStack.splice(-1, 1);
      state.stateStack = oldStateStack;
    },
    removeLastRedoState: (state) => {
      const oldRedoStack = state.redoStack;
      oldRedoStack.splice(-1, 1);
      state.redoStack = oldRedoStack;
    },
    updateCanvasState: (state, action) => {
      state.stateStack = action.payload.stateStack;
      state.currentState = action.payload.currentState;
    },
    addRedoState: (state, action) => {
      state.redoStack = [...state.redoStack, action.payload];
    },
    addUndoState: (state, action) => {
      state.stateStack = [...state.stateStack, action.payload];
    },
    clearCanvasState: (state) => {
      state.stateStack = [];
      state.redoStack = [];
    },
    setIsContentChange: (state, action) => {
      state.isContentChange = action.payload;
      if (action.payload) state.toogleAutoSaveRevision = true;
    },
    haveSaved: (state) => {
      state.toogleAutoSaveRevision = false;
    },
  },
});
export default stateManagerSlice.reducer;
export const {
  removeLastStackState,
  removeLastRedoState,
  updateCanvasState,
  addRedoState,
  addUndoState,
  clearCanvasState,
  setIsContentChange,
  haveSaved,
} = stateManagerSlice.actions;
export const stateManagerSelector = (state) => state.stateManager;
